// What each cleanup does to a Clip's lifecycle fields, in one place so the
// Data Cleanup console and the App Claims tab say the same thing.

// Removing app records (Firestore cleanup, or a delete from the App Claims tab).
export const APP_RECORD_DELETE_EFFECTS: string[] = [
  'Removes the chosen app records now.',
  'Registration becomes missing only if no other record names the Clip.',
  'The current filter fields are re-resolved from any surviving record, so the install date and baseline can stay.',
  'First filter installed and the filter history stay until a Return to inventory.',
];

// Return to inventory, leading with the lifecycle effect.
export const RETURN_TO_INVENTORY_CLEARS =
  'Clears Activated, Registered, First reading, First filter installed, Setup complete and Decommissioned.';
export const RETURN_TO_INVENTORY_KEEPS = 'Keeps Created, the serial, calibration and history.';
export const RETURN_TO_INVENTORY_DISCARDS =
  'Anything this Clip uploads before it is set up again is discarded; hardware-reset it if it stays on the bench.';

export const RETURN_TO_INVENTORY_LEAD = [
  RETURN_TO_INVENTORY_CLEARS,
  RETURN_TO_INVENTORY_KEEPS,
  RETURN_TO_INVENTORY_DISCARDS,
].join(' ');

// Settings tab: what the Decommissioned flag does.
export const DECOMMISSIONED_EFFECT =
  'Marks the Clip as retired. It stops no-connection alerts, setup reminders and health scoring for this Clip, and leaves it out of equipment counts. Its data is kept.';
